import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { TimepointService } from '../../../../core/services/timepoint.service';
import { BauprojektEproidRequestMeta, GwrbauprojektService } from '../../../../core/gwr-api';
import { GwrFormService } from '../../../gwr-form.service';
import { AbstractSearchComponent } from '../../../../shared/components/abstract-component/abstract-search.component';
import { SearchStateService } from '../../../../shared/services/search-state.service';
import { SearchMode } from '../../../../shared/enum/searchMode';
import { MetaDirective } from '../../../../shared/directives/meta.directive';
import { CapFormRowDirective } from '../../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../shared/directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-gwr-bauprojekt-suche-eproid',
  templateUrl: './gwr-bauprojekt-suche-eproid.component.html',
  styleUrls: ['./gwr-bauprojekt-suche-eproid.component.scss'],
  imports: [
    FormsModule,
    MetaDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe
  ]
})
export class GwrBauprojektSucheEproidComponent extends AbstractSearchComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('form', { static: false })
  form: NgForm;

  @ViewChild('eproidTemplate', { static: false })
  eproidField: ElementRef;

  eproid: BauprojektEproidRequestMeta;
  private subscription: Subscription;

  constructor(
    stateService: SearchStateService,
    private bauprojektService: GwrbauprojektService,
    private route: ActivatedRoute,
    private router: Router,
    private formService: GwrFormService,
    private timepointService: TimepointService
  ) {
    super(stateService);
  }

  ngOnInit() {
    this.subscription = this.bauprojektService.searchBauprojektEproidTemplate().subscribe((template) => {
      this.eproid = this.copyLastRequest(template, SearchMode.searchFachId);
    });
  }

  onSubmit(): void {
    this.timepointService.resetTimepoint();
    this.stateService.lastSearchMode = SearchMode.searchFachId;
    this.stateService.lastRequest = this.eproid;
    this.formService.submit(this.form, SearchMode.searchFachId, this.eproid, this.router, this.route, true);
  }

  onReset() {
    this.form.reset();
    this.subscription = this.bauprojektService.searchBauprojektEproidTemplate().subscribe((template) => {
      this.eproid = template;
      this.eproidField.nativeElement.focus();
    });
  }

  ngAfterViewInit() {
    this.eproidField.nativeElement.focus();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
